const envEmails = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_EXTERNAL_JOIN_BETA_EMAILS) || ''

export const EXTERNAL_JOIN_BETA_EMAILS = envEmails
  ? envEmails.split(',').map((e) => e.trim().toLowerCase()).filter(Boolean)
  : ['raghu@rithmo.ai', 'tim@rithmo.ai','charbel@rithmo.ai']

export const isExternalJoinEnabled = (email) =>
  EXTERNAL_JOIN_BETA_EMAILS.includes((email || '').toLowerCase())
